import { render, staticRenderFns } from "./ShippingConditionDetail.vue?vue&type=template&id=0d0570e8&scoped=true"
import script from "./ShippingConditionDetail.vue?vue&type=script&lang=js"
export * from "./ShippingConditionDetail.vue?vue&type=script&lang=js"
import style0 from "./ShippingConditionDetail.vue?vue&type=style&index=0&id=0d0570e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0570e8",
  null
  
)

export default component.exports